import { Smartphone, Send } from 'lucide-react';
import {
  CommunicationsMockPage,
  MockPrimaryButton,
} from './CommunicationsMockShell';

const NotificationsPushPage = () => (
  <CommunicationsMockPage
    title="Push notifications"
    description="Device push campaigns and delivery. Mock until push APIs are wired."
    crumbs={[
      { label: 'Communications', href: '/admin/communications/notifications' },
      { label: 'Notifications' },
      { label: 'Push' },
    ]}
    icon={Smartphone}
    actions={<MockPrimaryButton><Send className="h-4 w-4" /> New push</MockPrimaryButton>}
    stats={[
      { label: 'Campaigns', value: '9' },
      { label: 'Devices', value: '84.2k' },
      { label: 'Opted out', value: '2.1%' },
      { label: 'Bounce (7d)', value: '0.4%' },
    ]}
    columns={['Campaign', 'Status', 'Audience', '']}
    rows={[
      {
        id: '1',
        primary: 'weekend_flash_sale',
        secondary: 'Title: Weekend deals inside',
        badge: 'Scheduled',
        badgeTone: 'info',
        meta: 'Active users GH',
      },
      {
        id: '2',
        primary: 'escrow_reminder_d3',
        secondary: 'Complete your escrow…',
        badge: 'Sent',
        badgeTone: 'success',
        meta: 'Pending escrow',
      },
      {
        id: '3',
        primary: 'app_update_nudge',
        secondary: 'Update available',
        badge: 'Draft',
        badgeTone: 'warn',
        meta: 'iOS < 2.4',
      },
    ]}
  />
);

export default NotificationsPushPage;
